<template>
  <div class="flex flex-col lg:flex-row">
    <!-- Main Content -->
    <div class="flex-1 lg:mr-6 mb-6 lg:mb-0">
      <vs-card class="h-full">
        <div class="pt-3 px-3 flex flex-wrap w-full justify-between">
          <h4>Patient Details</h4>
          <button
            class="underline text-base border-none bg-white shadow-none cursor-pointer mt-1"
            color="primary"
            type="flat"
            @click="editPatientDetailsDrawer()"
          >
            Edit
          </button>
        </div>
        <div class="flex flex-wrap">
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="firstName">First Name</label>
              <p id="firstName">{{ firstName }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="lastName">Last Name</label>
              <p id="lastName">{{ lastName }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="dateOfBirth">DOB</label>
              <p id="dateOfBirth">{{ moment(dateOfBirth).format("DD/MM/YYYY") }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="email">Email</label>
              <p id="email">{{ email }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="gender">Gender</label>
              <p id="gender">{{ gender | capitalize }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="address">Address</label>
              <p id="address">{{ address }}</p>
            </div>
          </div>
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="contactNumber">Contact Number</label>
              <p id="contactNumber">{{ contactNumber }}</p>
            </div>
          </div>

          <div v-if="displayHealthTreatment" class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="medicare">Medicare</label>
              <div class="mt-2">
                <vs-button 
                  @click="showMedicareModal = true"
                  type="filled"
                  size="medium"
                  class="custom-medicare-btn"
                >
                  View Details
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
      
      <MedicalDetail
        v-if="check_has_permission('viewPatientMedicalDetail')"
        :allergies="allergies"
        :regularMedications="regularMedications"
        :previousMedicalDiagnoses="previousMedicalDiagnoses"
      />
    </div>
    
    <!-- Files Sidebar -->
    <PatientFilesSection 
      :patientId="$route.params.patientId"
      :showFilesFeature="showFilesFeature"
      @viewPatientFiles="$emit('viewPatientFiles', $route.params.patientId)"
    />

    <!-- Medicare Details Modal -->
    <MedicareDetailsDialog
      :is-visible="showMedicareModal"
      :medicare-data="patientData"
      @update:is-visible="showMedicareModal = $event"
    />

    <SideDrawerEditPatient
      :patient=patientData
      @refetchPatientDetail=rerfreshData
      ref="sideDrawerEditPatient"
    />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MedicalDetail from './MedicalDetail';
import PatientFilesSection from './PatientFilesSection.vue';
import MedicareDetailsDialog from './MedicareDetailsDialog.vue';
import SideDrawerEditPatient from '@/views/general-component/treatment-history/SideDrawerEditPatient.vue';
import moment from 'moment';
import { hasHealthTreatment } from '@/utils/healthTreatment';
import FEATURE_FLAGS from '@/constants/featureFlags';

export default {
  name: 'PatientDetail',

  components: {
    MedicalDetail,
    PatientFilesSection,
    MedicareDetailsDialog,
    SideDrawerEditPatient,
  },
  props: {
    backRoute: {
      type: String,
      default: 'PatientManagement',
    },
  },
  data() {
    return {
      email: '',
      dateOfBirth: '',
      profileImage: '',
      allergies: [],
      regularMedications: [],
      previousMedicalDiagnoses: [],
      status: '',
      address: '',
      lastName: '',
      contactNumber: '',
      firstName: '',
      gender: '',
      showFilesFeature: false,
      showMedicareModal: false,
      patientTreatments: [],
      patientData: {
        email: '',
        dateOfBirth: '',
        profileImage: '',
        allergies: [],
        regularMedications: [],
        previousMedicalDiagnoses: [],
        status: '',
        address: '',
        lastName: '',
        contactNumber: '',
        firstName: '',
        gender: '',
        medicareInfo: {
          medicareCardName: '',
          medicareNumber: '',
          medicareRefNumber: '',
          medicareExpiryDate: '',
        },
        ihiNumber: '',
      },
      medicareInfo:{
        medicareCardName: '',
        medicareNumber: '',
        medicareRefNumber: '',
        medicareExpiryDate: '',
      },
      ihiNumber: '',
    };
  },
  computed: {
    displayHealthTreatment() {
      return hasHealthTreatment(this.patientData.medicareInfo, this.patientData.ihiNumber);
    },
  },
  methods: {
    ...mapActions('patient', ['patientDetail', 'patientTreatmentList2']),
    moment(date) {
      return moment(date);
    },
    async getPatientDetail(patientId) {
      await this.patientDetail(patientId)
        .then((res) => {
          if (res.data.data.permissions) {
            this.$store.commit('UPDATE_USER_PERMISSION', res.data.data.permissions);
          }
          const patientData = res.data.data;
          this.patientData = patientData;
          this.dateOfBirth = patientData.dateOfBirth;
          this.profileImage = patientData.profileImage;
          this.allergies = patientData.allergies;
          this.regularMedications = patientData.regularMedications;
          this.previousMedicalDiagnoses = patientData.previousMedicalDiagnoses;
          this.status = patientData.status;
          this.address = patientData.address;
          this.lastName = patientData.lastName;
          this.contactNumber = patientData.contactNumber;
          this.firstName = patientData.firstName;
          this.gender = patientData.gender;
          this.email = patientData.email;
          this.patientData.medicareInfo = {
            medicareCardName: patientData.medicareCardName,
            medicareNumber: patientData.medicareNumber,
            medicareRefNumber: patientData.medicareRefNumber,
            medicareExpiryDate: patientData.medicareExpiryDate,
          };
          this.patientData.ihiNumber = patientData.ihiNumber;
        })
        .catch((err) => console.log('*******************', err));
    },
    
    async getPatientTreatments(patientId) {
      try {
        const params = {
          patientId: patientId,
          limit: 100,
        };
        const response = await this.patientTreatmentList2(params);
        this.patientTreatments = response.data.data.docs || [];
      } catch (err) {
        console.log('Error fetching patient treatments:', err);
        this.patientTreatments = [];
      }
    },
    
    formatIHINumber(ihiNumber) {
      if (!ihiNumber) return null;
      
      // Remove all spaces first, then format consistently
      const cleanNumber = ihiNumber.replace(/\s/g, '');
      return cleanNumber.replace(/(.{4})/g, '$1 ').trim();
    },

    editPatientDetailsDrawer() {
      this.$refs.sideDrawerEditPatient.openSideDrawer();
    },

    rerfreshData() {
      this.$vs.loading();
      this.getPatientDetail(this.$route.params.patientId)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  async created() {
    let patientId = this.$route.params.patientId;
    await this.getPatientDetail(patientId);
    await this.getPatientTreatments(patientId);
    
    this.showFilesFeature = await this.$ld.getFlag(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS, false);
    
    this.$ld.subscribe(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS, (changes) => {
      this.showFilesFeature = changes.current;
    });
  },
  destroyed() {
    this.$ld.unsub(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS);
  },
};
</script>

<style>
p {
  font-size: 15px;
  font-weight: 500;
}

/* Medicare Section Styles */
.custom-medicare-btn {
  background-color: #D3F2EE !important;
  color: #0F9E8B !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  padding: 7px 26px !important;
}

.custom-medicare-btn:hover {
  background-color: #B8E8E0 !important;
  transform: translateY(-1px);
}

/* Medicare Modal Styles */
.medicare-modal .vs-popup {
  max-width: 600px;
}

.medicare-modal h4 {
  padding: 20px 20px 0 20px;
}

.medicare-content {
  padding: 20px;
}

.medicare-field:last-child {
  border-bottom: none;
}

.medicare-field label {
  color: #109D8C;
  font-weight: 500;
  font-size: 14px;
  display: block;
  margin-bottom: 4px;
}

.medicare-field p {
  color: #262928;
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 16px 0;
}

.medicare-separator {
  border: none;
  height: 1px;
  background: #E3DDD7;
  margin: 16px 0;
}

.no-medicare-info {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}
</style>